import React, { useState } from "react";
import { Card, Button } from "antd";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../../utils/routes";
import CVPreviewModal from "../../../Personnel/Profile/Components/CVPreviewModal";
import useFirmService from "../../../../services/useFirmService";

const ApplicantCard = ({ applicant }) => {
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");

  const { personnel, createdAt } = applicant;
  const { id, name, surname } = personnel;

  const { useGetCvPreview, useGetCvPreviewPdf } = useFirmService();
  const { mutateAsync: getCvPreview, isPending: isGetCvPreviewLoading } =
    useGetCvPreview();
  const { mutateAsync: getCvPreviewPdf, isPending: isGetCvPreviewPdfLoading } =
    useGetCvPreviewPdf();

  const navigate = useNavigate();

  const handleGetCvPreview = async () => {
    try {
      const response = await getCvPreview(id);
      setPreviewHtml(response.data);
      setIsPreviewModalOpen(true);
    } catch (error) {}
  };

  const handleDownloadPdf = async () => {
    try {
      const response = await getCvPreviewPdf(id);
      const pdfUrl = response.data;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = pdfUrl;

      // Extract filename from URL or use default name
      const fileName = "cv.pdf";
      link.download = fileName;

      // Append to document, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      // Handle error
    }
  };

  const goToDocumentUploadPage = () => {
    let path = `${PageRoutes.documentUploadFirm}`;
    console.log("applicatn is", personnel);
    navigate(path, {
      state: {
        personnelName: name,
        personnelSurname: surname,
        personnelId: id,
      },
    });
  };

  const getLocation = () => {
    const { district, city } = personnel.personnelAddress || {};

    if (!personnel.personnelAddress) return "Adres bilgisi yok";

    if (district?.name && district?.city?.name) {
      return `${district.name} / ${district.city.name}`;
    }

    if (city?.name) {
      return city.name;
    }

    return (
      personnel.personnelAddress.district?.city?.country?.name ||
      "Adres bilgisi yok"
    );
  };

  const getDaysAgo = () => {
    const applied = new Date(createdAt);
    const today = new Date();
    const diffTime = Math.abs(today - applied);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  return (
    <>
      <Card style={styles.card}>
        <div style={styles.header}>
          <div style={styles.id}>#{id}</div>
          <div style={styles.daysAgo}>{getDaysAgo()} gün önce</div>
        </div>

        <div style={styles.info}>
          <div style={styles.infoItem}>
            <UserOutlined style={styles.icon} />
            <span>
              {name} {surname}
            </span>
          </div>

          <div style={styles.infoItem}>
            <EnvironmentOutlined style={styles.icon} />
            <span>{getLocation()}</span>
          </div>
        </div>

        <Button
          onClick={() => {
            handleGetCvPreview();
          }}
          type="primary"
          style={styles.button}>
          CV görüntüle
        </Button>
        <Button
          onClick={goToDocumentUploadPage}
          type="primary"
          style={styles.button}>
          Doküman Yükle
        </Button>
      </Card>
      <CVPreviewModal
        isOpen={isPreviewModalOpen}
        onClose={() => setIsPreviewModalOpen(false)}
        htmlContent={previewHtml}
        onDownload={handleDownloadPdf}
        isDownloading={isGetCvPreviewPdfLoading}
      />
    </>
  );
};

export default ApplicantCard;

const styles = {
  card: {
    margin: 16,
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  id: {
    fontWeight: "bold",
    color: "#1890ff",
  },
  daysAgo: {
    color: "#8c8c8c",
    fontSize: 14,
  },
  info: {
    marginBottom: 16,
  },
  infoItem: {
    display: "flex",
    alignItems: "center",
    marginBottom: 8,
  },
  icon: {
    marginRight: 8,
    color: "#8c8c8c",
  },
  button: {
    width: "100%",
    marginBottom: 20,
  },
};
